import { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import ClassetCalendar from '../../../../../classetComponents/classetCalender';
import ClassetInputText from '../../../../../classetComponents/classetInputText';
import { StudentAdmissionChangeUtils } from '../utils';
import { BUTTON_STYLES } from '../constants';

class NewFeeInfoDialog extends Component {
    renderHeader = () => {
        const { onBack } = this.props;
        
        return (
            <div className='flex align-items-center text-center text-black-alpha-80'>
                <span 
                    className="back-arrow-icon"
                    onClick={onBack}
                >
                    <i className="pi pi-arrow-left" style={{ fontSize: '1.5rem', color: '#333' }}></i>
                </span>
                <h3 style={{ margin: 0, flex: 1 }}>New Fee Types</h3>
            </div>
        );
    };

    renderFooter = () => {
        const { onApprove, onCancel } = this.props;
        
        return (
            <div className="flex flex justify-content-center my-3">
                <Button
                    className="formAddButton px-4 mr-2"
                    style={BUTTON_STYLES.APPROVE}
                    onClick={onApprove}
                >
                    <p className="formAddButtonText">Approve</p>
                </Button>
                <Button 
                    className="cancelButtonn" 
                    style={{ width: "164px", height: "48px" }} 
                    onClick={onCancel}
                >
                    <p className="cancelButtonnText">Cancel</p>
                </Button>
            </div>
        );
    };

    renderFeeTypeSummary = () => {
        const { selectedFeeStructure, installmentData } = this.props;
        
        const uniqueFeeTypes = StudentAdmissionChangeUtils.getUniqueFeeTypes(selectedFeeStructure);

        if (uniqueFeeTypes.length === 0) return null;

        // Filter out one-time fees from summary
        const installmentFeeTypes = uniqueFeeTypes.filter(fee => fee && !fee?.isOneTime);

        if (installmentFeeTypes.length === 0) return null;

        return (
            <div className="mb-4 p-3" style={{ borderRadius: '8px' }}>
                <h4 className="mb-3">Add Fee Amount</h4>
                <div className="flex flex-wrap gap-3">
                    {installmentFeeTypes?.map((feeType, feeTypeIndex) => {
                        if (!feeType) return null;
                        const enteredAmount = StudentAdmissionChangeUtils.calculateTotalEnteredAmount(installmentData, feeType);
                        const amountColor = StudentAdmissionChangeUtils.getAmountColor(enteredAmount, feeType.totalFee || 0);

                        return (
                            <div
                                key={feeType.feeTypeId || feeType._id}
                                className="flex align-items-center p-3"
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '6px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                    minWidth: '200px'
                                }}
                            >
                                <div className="flex-column">
                                    <div className="font-semibold mb-2">
                                        {feeType.feeType}
                                    </div>
                                    <div className="flex align-items-center gap-2">
                                        <span style={{ color: amountColor }}>
                                            ₹{enteredAmount}
                                        </span>
                                        <span>/</span>
                                        <span style={{ color: '#4CAF50' }}>
                                            ₹{feeType.totalFee || 0}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    renderOneTimeFees = () => {
        const { oneTimeFees, isShowInstallmentInfo, onOneTimeDueDateChange } = this.props;
        
        if (!oneTimeFees?.length || !isShowInstallmentInfo) return null;

        return (
            <div className="mb-4">
                <h4 className="text-xl font-semibold mb-2">One Time Fees</h4>
                <DataTable value={oneTimeFees} responsiveLayout="scroll">
                    <Column field="feeType" header="Fee Type" />
                    <Column field="totalFee" header="Total Fee" />
                    <Column
                        header="Due Date"
                        body={(rowData) => (
                            <ClassetCalendar
                                className="border-calendar"
                                width={'280px'}
                                height={'48px'}
                                inputClassName="font-semibold"
                                calendarMode={'single'}
                                value={StudentAdmissionChangeUtils.getValidDate(rowData?.dueDate)}
                                onChange={(e) => onOneTimeDueDateChange(e.value, rowData)}
                                placeholder="Select Due Date"
                                yearRange="2000:2050"
                                disabled={true}
                            />
                        )}
                    />
                </DataTable>
            </div>
        );
    };

    renderInstallments = () => {
        const { 
            installmentData, 
            selectedFeePlan, 
            isShowInstallmentInfo,
            onPercentageChange,
            onCalculatedFeeChange
        } = this.props;
        
        if (!isShowInstallmentInfo) return null;

        return installmentData?.map((installment, installmentIndex) => {
            const planInstallment = selectedFeePlan?.installments?.find(
                i => i.installmentId === installment.installmentId
            );

            return (
                <div key={installmentIndex} className="mb-4">
                    <div className="flex align-items-center gap-3 mb-2">
                        <h4 className="m-0">
                            {installment.installment} - {planInstallment ? moment(planInstallment.date).format('DD/MM/YYYY') : 'Date not set'}
                        </h4>
                    </div>
                    <DataTable value={installment.feeTypes} responsiveLayout="scroll">
                        <Column field="feeType" header="Fee Type" />
                        <Column field="totalFee" header="Total Fee" />
                        <Column
                            header="Percentage"
                            body={(rowData) => (
                                <ClassetInputText
                                    value={rowData.percentage || 0}
                                    onChange={(e) => onPercentageChange(e, installmentIndex, rowData)}
                                    placeholder="Percentage"
                                    keyfilter="num"
                                    min={0}
                                    max={100}
                                    className="p-inputtext-sm"
                                    style={{ width: '100px' }}
                                    disabled={true}
                                />
                            )}
                        />
                        <Column
                            header="Calculated Fee"
                            body={(rowData) => (
                                <ClassetInputText
                                    value={rowData.calculatedFee || 0}
                                    onChange={(e) => onCalculatedFeeChange(e, installmentIndex, rowData)}
                                    placeholder="Calculated Fee"
                                    keyfilter="num"
                                    min={0}
                                    max={rowData.totalFee}
                                    className="p-inputtext-sm"
                                    style={{ width: '100px' }}
                                    disabled={true}
                                />
                            )}
                        />
                    </DataTable>
                </div>
            );
        });
    };

    render() {
        const { visible, onHide } = this.props;

        return (
            <Dialog
                header={this.renderHeader}
                draggable={false}
                closable={true}
                visible={visible}
                style={{ width: '80%', height: "80%" }}
                onHide={onHide}
                footer={this.renderFooter}
                modal
            >
                <div className="mt-2">
                    {this.renderFeeTypeSummary()}
                    {this.renderOneTimeFees()}
                    {this.renderInstallments()}
                </div>
            </Dialog>
        );
    }
}

export default NewFeeInfoDialog;
